import { render, staticRenderFns } from "./hend.vue?vue&type=template&id=4b7123ed&scoped=true&"
import script from "./hend.vue?vue&type=script&lang=js&"
export * from "./hend.vue?vue&type=script&lang=js&"
import style0 from "./hend.vue?vue&type=style&index=0&id=4b7123ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7123ed",
  null
  
)

export default component.exports